import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { EndpointService } from '@app/core';

@Injectable()
export class LoadInformationExcelDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) {}

  /**
   * Subir documento al sistema para las tareas
   *
   * @param {FormData} formData
   * @returns {Observable<boolean>}
   * @memberof LoadInformationExcelDataService
   */
  uploadFileTask(formData: FormData): Observable<boolean> {
    return new Observable(obs => {
      this.http
      .skipErrorHandler()
        .post(this.api.get('chargeTaskData'), formData, {
          observe: 'response'
        })
        .subscribe(
          res => {
            this.toastr.success('Archivos subidos correctamente.', 'Operación exitosa');
            obs.next(true);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.error('Lo sentimos ha ocurrido un error, intentelo de nuevo.', 'Fallo de subida');
            }
            obs.next(false);
            obs.error(err);
          }
        );
    });
  }

  /**
   * Descargar informe de la tarea
   *
   * @param {number} idTask
   * @returns {Observable<any>}
   * @memberof LoadInformationExcelDataService
   */
  dowloadFileTask(idTask: number): Observable<any> {
    return new Observable(obs => {
      this.http
        .skipErrorHandler()
        .get(this.api.get('chargeTaskData', [idTask]), {
          observe: 'response'
        })
        .subscribe(
          res => {
            obs.next(res.body);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.error('Ha ocurrido un error inesperado, verifique que la plantilla' +
                                 ' tenga un formato correcto y el documento se haya subido', 'Fallo de descarga');
            }
            obs.error(err);
          }
        );
    });
  }

  /**
   * Subir documento al sistema para las maestras
   *
   * @param {FormData} formData
   * @returns {Observable<boolean>}
   * @memberof LoadInformationExcelDataService
   */
  uploadFileMaster(formData: FormData): Observable<boolean> {
    return new Observable(obs => {
      this.http
      .skipErrorHandler()
        .post(this.api.get('chargeMasterData'), formData, {
          observe: 'response'
        })
        .subscribe(
          res => {
            this.toastr.success('Archivos subidos correctamente.', 'Operación exitosa');
            obs.next(true);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.error('Lo sentimos ha ocurrido un error, intentelo de nuevo.', 'Fallo de subida');
            }
            obs.next(false);
            obs.error(err);
          }
        );
    });
  }

  /**
   * Descargar informe de la tarea
   *
   * @param {number} idMaster
   * @returns {Observable<any>}
   * @memberof LoadInformationExcelDataService
   */
  dowloadFileMaster(idMaster: number): Observable<any> {
    return new Observable(obs => {
      this.http
        .skipErrorHandler()
        .get(this.api.get('chargeMasterData', [idMaster]), {
          observe: 'response'
        })
        .subscribe(
          res => {
            obs.next(res.body);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.error('Ha ocurrido un error inesperado, intentelo de nuevo mas tarde.', 'Fallo de descarga');
            }
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/load-information-excel/shared/load-information-excel.data.service.ts